// extracted by mini-css-extract-plugin
export default {"container":"new-preventive-modal_container__skrdA"};